import React from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { selectTopNaviLinks } from '../../selectors/menuSelectors'
import './mainNavigation.pcss'

const MainNavigation = () => {
  const links = useSelector(selectTopNaviLinks).toJS()

  return (
    <nav aria-label='Osiot'>
      <ul className='main-navigation'>
        { links.map(link => (
          <li key={ link.to } className={ classnames({active: link.topNaviActive}) }>
            <Link to={ link.to }>{ link.topNaviTitle }</Link>
          </li>
        )) }
      </ul>
    </nav>
  )
}

export default MainNavigation
